module.exports = __webpack_public_path__ + "img/pdf.941903c0.png";